interface StandardItemProps {
    label: string;
    value: string;
    labelSuffix?: string;
    valueSuffix?: string;
    additionalValue?: string;
    additionalValueSuffix?: string;
}

export default function StandardItem({ label, value, labelSuffix = "", valueSuffix = "", additionalValue = "", additionalValueSuffix = "" }: StandardItemProps) {
    return (
        <div className="flex justify-between mb-[calc(8*var(--vh-unit)) ]">
            <span className="text-[var(--color-text-sub01)] text-[calc(20*var(--vh-unit))] widescreen:font-medium font-bold leading-[calc(26*var(--vh-unit))] tracking-[calc(-0.4*var(--vh-unit))]">{label}{labelSuffix}</span>
            <span className="text-[var(--color-text-sub01)] text-[calc(20*var(--vh-unit))] widescreen:font-medium font-bold leading-[calc(26*var(--vh-unit))] tracking-[calc(-0.4*var(--vh-unit))]">{value}{valueSuffix}{additionalValue}{additionalValueSuffix}</span>
        </div>
    );
}
